import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Divider,
  Flex,
  Grid,
  Select,
  TextInput,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { IconArrowBack, IconCheck } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryMdm,
} from "../../_base/_const/_constVar";
import { MessageResponse } from "../../model/MessageResponse";
import {
  CreateTestingTechniqueModel,
  TblTestingTechniqueDetailCommand,
} from "../../model/TblTestingTechniqueHeader";
import ListProductDetail from "./ListProductDetail";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { getMasterOrgSelect } from "../../service/getSelectApi";
import { getValueById } from "../../_base/helper/FunctionHelper";

const CreateTestingTechnique = () => {
  const entity = {
    id: null,
    code: null,
    description: null,
    techiqueWorkId: 5,
    masterOrgId: JSON.parse(localStorage.getItem("userLoginHeader") ?? "")
      ?.branchId,
    inventoryId: null,
    note: null,
    tblTestingTechniqueDetailCommands: null,
  };

  const form = useForm<CreateTestingTechniqueModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
  });

  const navigate = useNavigate();
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const boxTopRef = useRef<number>(0);
  const [bottomBoxHeight, setBottomBoxHeight] = useState(0);
  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);
  const [listProductTest, setListProductTest] = useState<
    TblTestingTechniqueDetailCommand[]
  >([]);

  const getCreate = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      "/api/v1/TblTestingTechniqueHeader/create?prefix=KT",
    );

    if (res && res.success) {
      const result = res.data;
      form.setValues((prev) => ({
        ...prev,
        code: result.transactionNumber,
        createDate: result.createDate,
      }));
    }
  };

  const fetchDataMasterOrg = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `[${item.att1}] - ${item.text}`,
          value: item.value?.toString(),
          code: item.att1?.toString(),
        }));
      setDataBranch(data);
    }
  };

  const handleSubmit = async (dataSubmit: CreateTestingTechniqueModel) => {
    setLoadingButton(true);
    const res = await repositoryDelivery.post<
      MessageResponse<CreateTestingTechniqueModel>
    >("/api/v1/TblTestingTechniqueHeader/create", {
      ...dataSubmit,
      tblTestingTechniqueDetailCommands: listProductTest,
    });

    if (res && res.success) {
      NotificationExtension.Success("Tạo mới thành công !");
      createProductNotInSystem();
      setTimeout(() => {
        navigate("/testing/testing-technique");
        setLoadingButton(false);
      }, 1000);
    } else {
      setLoadingButton(false);
    }
  };

  const createProductNotInSystem = async () => {
    const dataSubmit = listProductTest
      ?.filter((item) => item.notInSystem)
      ?.map((i) => ({
        serial: i.serialCode,
        itemId: 0,
        itemCode: i.itemCode,
        itemName: i.itemName,
        unitOfMeasure: i.actribute4,
      }));
    await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblSerialNotInSystem/create",
      dataSubmit,
    );
  };

  useEffect(() => {
    getCreate();
    fetchDataMasterOrg();
  }, []);

  useEffect(() => {
    const updateHeight = () => {
      if (boxTopRef.current) {
        const boxTopHeight = boxTopRef.current;
        const totalHeight = window.innerHeight;
        const calculatedBottomHeight = totalHeight - boxTopHeight;
        setBottomBoxHeight(calculatedBottomHeight);
      }
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <Box
      component="form"
      onSubmit={form.onSubmit((e) => {
        handleSubmit(e);
      })}
    >
      <Box
        ref={(el) => {
          if (el) boxTopRef.current = el.offsetHeight;
        }}
      >
        <Flex justify={"end"} align={"center"} gap={"md"}>
          <Button
            type="button"
            color="red"
            onClick={() => {
              navigate(-1);
            }}
            leftSection={<IconArrowBack size={18} />}
            loading={loadingButton}
            disabled={loadingButton}
          >
            Quay lại
          </Button>
          <Button
            type="submit"
            color={"teal"}
            leftSection={<IconCheck size={18} />}
            loading={loadingButton}
            disabled={
              loadingButton ||
              !listProductTest.every(
                (item) =>
                  item.itemCode &&
                  item.actribute4 &&
                  item.itemCode.length > 0 &&
                  item.actribute4.length > 0,
              )
            }
          >
            Lưu
          </Button>
        </Flex>
        <Divider
          my="xs"
          label={<Badge color="blue">Thông tin tạo mới</Badge>}
          labelPosition="center"
        />
        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              label="Mã kiểm tra"
              placeholder="Mã kiểm tra"
              {...form.getInputProps("code")}
              variant="filled"
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              readOnly
              variant="filled"
              label="Ngày phân công"
              placeholder="Ngày phân công"
              value={new Date()}
              locale="vi"
              valueFormat="DD/MM/YYYY"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              label="Chi nhánh"
              placeholder="Chi nhánh"
              data={dataBranch?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              value={JSON.parse(
                localStorage.getItem("userLoginHeader") ?? "",
              )?.branchId?.toString()}
              variant="filled"
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              label="Yêu cầu dịch vụ"
              placeholder="Chọn dịch vụ yêu cầu"
              data={[
                { value: "1", label: "Lắp ráp(mới)" },
                { value: "2", label: "Kiểm tra(mới)" },
                { value: "3", label: "Lắp ráp(mới) + Kiểm tra(mới)" },
                { value: "4", label: "Kiểm tra sản phẩm BH NCC" },
                { value: "5", label: "Test khác" },
              ]}
              value={form.getValues()?.techiqueWorkId?.toString()}
              {...form.getInputProps("techiqueWorkId")}
              onChange={(e) =>
                form.setValues((prev) => ({
                  ...prev,
                  techiqueWorkId: e ? Number(e) : 1,
                }))
              }
              variant="filled"
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
            <TextInput
              key={form.key("description")}
              label="Nội dung phân công"
              placeholder="Nhập nội dung phân công"
              {...form.getInputProps("description")}
            />
          </Grid.Col>
        </Grid>
        <Divider
          my="xs"
          label={<Badge color="blue">Thông tin sản phẩm</Badge>}
          labelPosition="center"
        />
      </Box>
      <ListProductDetail
        isDetail={true}
        height={bottomBoxHeight - 210}
        listProductTest={listProductTest}
        setListProductTest={setListProductTest}
        branchCode={getValueById(
          form.getValues()?.masterOrgId?.toString() ?? "",
          dataBranch,
          "code",
        )}
      />
    </Box>
  );
};

export default CreateTestingTechnique;
